export default function menuStudentListByMenuId(menuId, showOnlyRelated) {
  const query = `{menuStudentListByMenuId(menuId:${menuId}, showOnlyRelated:${showOnlyRelated}){id, studentId, menuId, studentName, profilePhotoUrl, menuName, classes, active}}`;
  return query;
}
